import { useEffect, useState, useRef } from "react";
import { useGetCurrentSession } from "../../../apis/hooks/auth/session";

function useFreshUser(initialized, accessToken, setUser) {
  const [loading, setLoading] = useState(true);
  const isFetchingRef = useRef(false);

  const getCurrentSessionApi = useGetCurrentSession({
    options: { enabled: false },
  });

  useEffect(() => {
    if (getCurrentSessionApi.error) {
      setUser(null);
      return;
    }

    if (!initialized || !getCurrentSessionApi.data?.data?.user) {
      return;
    }

    setUser(getCurrentSessionApi.data.data.user);
  }, [initialized, getCurrentSessionApi.data, getCurrentSessionApi.error, setUser]);

  useEffect(() => {
    if (!initialized) {
      return;
    }

    if (!accessToken) {
      setUser(null);
      setLoading(false);
      return;
    }

    // Prevent multiple simultaneous requests
    if (isFetchingRef.current) {
      return;
    }

    isFetchingRef.current = true;
    getCurrentSessionApi
      .refetch()
      .then(() => {
        setLoading(false);
        isFetchingRef.current = false;
      })
      .catch(() => {
        setLoading(false);
        isFetchingRef.current = false;
      });
  }, [initialized, accessToken]);

  return { loading: loading };
}

export default useFreshUser;
